import SolidUserCircleIcon from 'heroicons/solid/user-circle.svg'
import SolidTrashIcon from 'heroicons/solid/trash.svg'
import SolidChevronLeftIcon from 'heroicons/solid/chevron-left.svg'
import SolidExclamationIcon from 'heroicons/solid/exclamation.svg'
import SolidInformationCircleIcon from 'heroicons/solid/information-circle.svg'
import SolidPrinterIcon from 'heroicons/solid/printer.svg'
import SolidXIcon from 'heroicons/solid/x.svg'
import SolidFilterIcon from 'heroicons/solid/filter.svg'

const solid = {
  SolidUserCircleIcon,
  SolidTrashIcon,
  SolidChevronLeftIcon,
  SolidExclamationIcon,
  SolidInformationCircleIcon,
  SolidPrinterIcon,
  SolidXIcon,
  SolidFilterIcon,
}

import OutlineEyeIcon from 'heroicons/outline/eye.svg'
import OutlineEyeOffIcon from 'heroicons/outline/eye-off.svg'
import OutlineHomeIcon from 'heroicons/outline/home.svg'
import OutlineCalendarIcon from 'heroicons/outline/calendar.svg'
import OutlineTableIcon from 'heroicons/outline/table.svg'
import OutlineCurrencyDollarIcon from 'heroicons/outline/currency-dollar.svg'
import OutlineSwitchHorizontalIcon from 'heroicons/outline/switch-horizontal.svg'
import OutlinePlus from 'heroicons/outline/plus.svg'
import OutlinePlusCircleIcon from 'heroicons/outline/plus-circle.svg'
import OutlineCollection from 'heroicons/outline/collection.svg'
import OutlineTrashIcon from 'heroicons/outline/trash.svg'
import OutlineExclamationIcon from 'heroicons/outline/exclamation.svg'
import OutlineInformationCircleIcon from 'heroicons/outline/information-circle.svg'
import OutlineSearchIcon from 'heroicons/outline/search.svg'
import OutlineRefreshIcon from 'heroicons/outline/refresh.svg'
import OutlineQuestionMarkCircleIcon from 'heroicons/outline/question-mark-circle.svg'
import OutlineClipboardCheckIcon from 'heroicons/outline/clipboard-check.svg'
import OutlineReceiptRefundIcon from 'heroicons/outline/receipt-refund.svg'
import OutlineDocumentSearchIcon from 'heroicons/outline/document-search.svg'
import OutlineDocumentTextIcon from 'heroicons/outline/document-text.svg'
import OutlineChevronDownIcon from 'heroicons/outline/chevron-down.svg'
import OutlineViewListIcon from 'heroicons/outline/view-list.svg'
import OutlineChevronUpIcon from 'heroicons/outline/chevron-up.svg'
import OutlineCogIcon from 'heroicons/outline/cog.svg'
import BoxIconFile from 'boxicons/svg/regular/bx-file.svg'
import BoxIconReceipt from 'boxicons/svg/regular/bx-receipt.svg'
import BoxIconDollarCircle from 'boxicons/svg/regular/bx-dollar-circle.svg'
import BoxIconCycling from 'boxicons/svg/regular/bx-cycling.svg'
import BoxIconCalendarExclamation from 'boxicons/svg/regular/bx-calendar-exclamation.svg'
import BoxIconTrip from 'boxicons/svg/regular/bx-trip.svg'

const outline = {
  OutlineChevronDownIcon,
  OutlineChevronUpIcon,
  OutlineEyeIcon,
  OutlineEyeOffIcon,
  OutlineHomeIcon,
  OutlineCalendarIcon,
  OutlineTableIcon,
  OutlineCurrencyDollarIcon,
  OutlineSwitchHorizontalIcon,
  OutlinePlus,
  OutlinePlusCircleIcon,
  OutlineCollection,
  OutlineTrashIcon,
  OutlineExclamationIcon,
  OutlineInformationCircleIcon,
  OutlineSearchIcon,
  OutlineRefreshIcon,
  OutlineQuestionMarkCircleIcon,
  OutlineClipboardCheckIcon,
  OutlineReceiptRefundIcon,
  OutlineDocumentSearchIcon,
  OutlineDocumentTextIcon,
  OutlineViewListIcon,
  OutlineCogIcon,
  BoxIconFile,
  BoxIconReceipt,
  BoxIconDollarCircle,
  BoxIconCycling,
  BoxIconCalendarExclamation,
  BoxIconTrip,
}

const icons = {
  ...solid,
  ...outline,
}

export default icons
